import { useMemo } from "react";
import { useGetJobTags, getGetJobTagsQueryKey } from "@workspace/api-client-react";
import TokenCombobox, { type TokenComboboxOption } from "@/components/token-combobox";

interface IndustryFocusComboboxProps {
  value: string[];
  onChange: (value: string[]) => void;
  placeholder?: string;
  disabled?: boolean;
}

const GROUPS = [
  { key: "discipline", label: "Discipline" },
  { key: "title", label: "Job Title" },
];

export default function IndustryFocusCombobox({
  value,
  onChange,
  placeholder = "Search disciplines and titles...",
  disabled = false,
}: IndustryFocusComboboxProps) {
  const { data: tags = [], isLoading } = useGetJobTags({
    query: { queryKey: getGetJobTagsQueryKey(), staleTime: 5 * 60 * 1000 },
  });

  const options = useMemo<TokenComboboxOption[]>(
    () => tags.map((t) => ({ label: t.label, group: t.type })),
    [tags],
  );

  return (
    <TokenCombobox
      value={value}
      onChange={onChange}
      options={options}
      groups={GROUPS}
      placeholder={placeholder}
      disabled={disabled}
      isLoading={isLoading}
      loadingLabel="Loading tags..."
      emptyLabel="No matching tags found"
      listAriaLabel="Discipline and title tags"
      idPrefix="industry-focus"
    />
  );
}
